<template>
  <div class="tagging_modal_container">
    <button
      @click="viewAddTagPopup($event)"
      class="btn_ic ace_sec"
      style="margin-top: -4px; margin-left: 10px; float: left; transform: rotate(-90deg);"
      :aria-label="$tf('clickToOpenTagsModal')"
      :title="$tf('clickToOpenTagsModal')"
      v-b-tooltip.hover>
        <span class="icon ic-tag action-icon-tagging"></span>
    </button>
    <add-tag-popup v-if="isShowTagPopup" :entity-data="taggingEntityData" @applyTagToEntity="saveAppliedTag" @closeAddTagModal="closeAddTagModal"></add-tag-popup>
  </div>
</template>

<script>
  import _ from 'lodash'
  import {  mapActions } from 'vuex'
  import { StorageFactory } from '../../../storageFactory'
  import AddTagPopup from '../../tagging/components/AddTagPopup'

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'tagging-action-menu',
    props: ['userIds', 'senderId'],
    components: {
      AddTagPopup
    },
    data: (vm) => {
      return {
        taggingTitle: '',
        appliedTagMap: {},
        taggingUserNames: [],
        isShowTagPopup: false,
        taggingEntityData: {},
        userPersonProfileMap: {},
        isActionModalVisible: false,
        userId: vm.senderId || localStore.getItem('userid')
      }
    },
    methods: {
      ...mapActions([
        'saveAppliedTagMap',
        'loadParticipantDisplayNames',
        'loadPersonProfilesForSelectedUsers'
      ]),
      async dataSetup () {
        let userUuids = _.map(this.userIds, 'userUuid')
        this.userPersonProfileMap = await this.loadPersonProfilesForSelectedUsers(userUuids)
        let uuidDisplayNameMap = await this.loadParticipantDisplayNames(userUuids)
        this.taggingUserNames = Object.values(uuidDisplayNameMap)
        this.taggingTitle = 'Apply Tags On '
        if (userUuids.length > 1) {
          this.taggingTitle += userUuids.length + ' people including ' + this.taggingUserNames.join(', ').replace(/,(?=[^,]*$)/, ' and')
        } else {
          this.taggingTitle += this.taggingUserNames[0]
        }
      },
      async viewAddTagPopup (event) {
        await this.dataSetup()
        this.isShowTagPopup = true
        let title = this.taggingTitle
        let modalPageLayer = $('.advisee_sec_crd')
        let hideAssinedTagsOnInit = true
        if (this.userIds.length === 1) {
          let userUuid = this.userIds[0].userUuid
          let person = this.userPersonProfileMap[userUuid]
          if (person.appliedTagMap) {
            this.appliedTagMap = person.appliedTagMap
            hideAssinedTagsOnInit = false
          }
        }
        this.taggingEntityData = {title: title, type: 'person', appliedTagMap: this.appliedTagMap, hideAssinedTagsOnInit: hideAssinedTagsOnInit}
        setTimeout(() => {
          this.isActionModalVisible = true
          this.$root.$emit('bv::show::modal', 'addTagPopup', event.target)
          modalPageLayer.addClass('active')
        }, 0)
      },
      async saveAppliedTag () {
        let recipients = []
        let appliedTagMap = _.cloneDeep(this.appliedTagMap)
        if (_.isEmpty(appliedTagMap)) {
          this.closeAddTagModal()
          return
        }
        let selectedUserIds = _.map(this.userIds, 'userUuid')
        _.forEach(selectedUserIds, (selectedUserId, index) => {
          let isLast = (index === (selectedUserIds.length - 1))
          let person = this.userPersonProfileMap[selectedUserId]
          let recipient = person.firstName + ' ' + person.lastName
          if (person) {
            recipients.push(recipient)
            let dbAppliedTagMap = person.appliedTagMap
            if (!dbAppliedTagMap) {
              dbAppliedTagMap = appliedTagMap
            } else {
              for (let key in appliedTagMap) {
                let tags = appliedTagMap[key]
                if (key in dbAppliedTagMap) {
                  let dbTags = dbAppliedTagMap[key]
                  let newTags = tags.filter(tag => !dbTags.some(dbTag => (tag.name === dbTag.name)))
                  newTags.forEach(newTag => {
                    dbTags.push(newTag)
                  })
                  this.$set(dbAppliedTagMap, key, dbTags)
                } else {
                  this.$set(dbAppliedTagMap, key, tags)
                }
              }
            }
            let data = {
              type: 'person',
              uuid: person.uuid,
              appliedTagMap: dbAppliedTagMap,
              careerCompetenciesMap: person.careerCompetenciesMap,
              careerCompetenciesList: person.careerCompetenciesList
            }
            this.saveAppliedTagMap(data).then(resp => {
              this.reloadTagsOnDashboard(selectedUserId, dbAppliedTagMap)
              if (isLast) {
                let names = recipients.join(', ').replace(/,(?=[^,]*$)/, ' and')
                let text = 'Tags applied successfully on <strong>' + names + '</strong>'
                this.closeAddTagModal()
                this.showNotification(text, 'success')
              }
            })
          }
        })
      },
      reloadTagsOnDashboard (userUuid, appliedTagMap) {
        let tags = []
        for (const [key, value] of Object.entries(appliedTagMap)) {
          value.forEach((tag, index) => {
            tags.push(tag.name)
          })
        }
        this.$parent.$parent.userTags[userUuid] = tags
      },
      closeAddTagModal () {
        this.taggingTitle = ''
        this.appliedTagMap = {}
        this.taggingUserNames = []
        this.taggingEntityData = {}
        this.userPersonProfileMap = {}
        this.$parent.active = false
        this.isActionModalVisible = false
        this.$parent.$parent.selectedUserUuids = []
        this.$parent.$parent.selectedItemMessage=''
        this.$parent.$parent.pageSelected = false
        let modalPageLayer = $('.advisee_sec_crd')
        modalPageLayer.removeClass('active')
      },
      showNotification (text, type) {
        this.$notify({
          group: 'notify',
          type: type,
          title: '',
          text: text
        })
      }
    }
  }
</script>

<style scoped>
  .action-icon-tagging {
    color: #157099;
    font-size: 24px;
  }

  .action-icon-tagging:hover {
    color: #b78b10;
  }
</style>



// WEBPACK FOOTER //
// src/app/adviseeTracker/components/TaggingActionMenu.vue